import React, {PureComponent} from 'react';
import {Box, Divider} from '@material-ui/core';
import {connect} from 'react-redux';
import './notification-block.scss';
import nitratIcon from '../../../assets/justmeasure_nitrat.png';
import {AppState} from '../../../state/store';
import {NotificationType} from '../../../api/api';
import {localized} from '../../../state/i18n/i18n';
import moment from 'moment';
import {DateFormatWithHours} from '../../../utilities/constants';
import BatteryAlertRoundedIcon from '@material-ui/icons/BatteryAlertRounded';
import {SvgIcon} from '@material-ui/core';

interface PropsFromParents {
  id?: number;
}

const mapStateToProps = (state: AppState, ownProps: PropsFromParents) => {
  return {
    notification: state.notificationReducer.notifications.find((notification) => notification.id === ownProps.id),
  };
};

type Props = Partial<ReturnType<typeof mapStateToProps>> & PropsFromParents;

export class NotificationBlock extends PureComponent<Props> {
  private getIcon = () => {
    if (this.props.notification?.type === NotificationType.LowBattery) {
      return <SvgIcon component={BatteryAlertRoundedIcon} color="primary" className="icon" />;
    }
    if (this.props.notification?.type === NotificationType.Nitrat) {
      return <img src={nitratIcon} alt="nitratIcon" className="icon" />;
    } else return <img src={nitratIcon} alt="nitratIcon" className="icon" />;
  };

  private getPayload = () => {
    if (this.props.notification && this.props.notification.payload === undefined) {
      return ' ';
    }
    if (this.props.notification?.type === NotificationType.LowBattery) {
      let result = localized('LowBattery');

      return result;
    } else if (this.props.notification?.type === NotificationType.Nitrat) {
      let result = localized('Nitrate') + ' ' + this.props.notification.payload!.toFixed(2) + ' mg/L';
      return result;
    }
  };

  private getTextLimitExceeded = () => {
    if (this.props.notification && this.props.notification.payload === undefined) {
      return ' ';
    }
    if (this.props.notification?.type === NotificationType.Nitrat) {
      let result = <Box className="notification-limit">{localized('LimitExceeded')}</Box>;

      return result;
    }
  };

  public render() {
    return (
      <div>
        <Box display="flex" className="notification-block">
          <Box display="flex" flexDirection="row">
            <Box className="notification-icon-row">{this.getIcon()}</Box>
            <Box>
              <Box flexDirection="row" display="flex" className="dateAndNameBox">
                <Box justifyContent="left" className="notification-device-name">
                  {this.props.notification?.deviceId}
                </Box>
                <Box className="notification-date">
                  {moment(this.props.notification?.timestamp).format(DateFormatWithHours)}
                </Box>
              </Box>
              {this.getTextLimitExceeded()}
              <Box className="notification-payload">{this.getPayload()}</Box>
            </Box>
          </Box>
        </Box>
        <Divider />
      </div>
    );
  }
}
export default connect(mapStateToProps, null)(NotificationBlock);
